import React, {Component} from 'react';
import {toast} from 'react-toastify';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter, Input} from 'reactstrap';
import NumberFormat from 'react-number-format';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import {UPDATE_AUDIT_STATUS} from "../../actions/ActionTypes";
import ConfirmModal from "../common/ConfirmModal";
import {downloadPDF} from "../common/Constants";
import ErrorMsg from "../common/ErrorMsg";
import loadingGIF from "../../public/assets/images/loading.gif";
import {
    REVIEW_COMPLETED, REVIEW_OPEN, COMPLIANCE_YES
} from "../complianceAudit/Constants";
import ComplianceAuditService from "../../services/ComplianceAuditService";


export default class AuditForm extends Component {
    
    state = {
        auditResponse: {
            id: 0,
            name: '', 
            description: '',
            responses: [],
            status: REVIEW_OPEN,
            // file_names: [],
        },
        isLoading: false,
        isPrintLoading: false,
        confirmationModalData: {},
       
    };

    componentDidMount() {
        this.getAuditForm();
    }

    getAuditForm = async () => {
        this.setState({isLoading: true});
        try {
            const {compensation, auditId, auditKPI} = this.props;
            
            const compId = compensation && compensation.id ? compensation.id : 0
            let result = await this.props.getAuditResponse(compId, auditKPI, auditId);
            if (result) {
                let auditResponse = {
                    id: result.id,
                    name: result.name, 
                    description: result.description,
                    responses: result.responses.map(response => {
                        return {
                            ...response,
                            audit_date: response.audit_date ? moment(response.audit_date) : null
                        }
                    }),
                    status: result.status,
                    score: result.score,
                }
                this.setState({auditResponse});
            }            
        } catch (error) {
            toast.error(<ErrorMsg errors={error}/>);
        }
        this.setState({isLoading: false});
    };

    handleAuditData = (e, index) => {
        const name = e.target.name;
        const value = e.target.value;
        const {auditResponse} = this.state;
        let responses = [...auditResponse.responses];
        
        if ((name === 'form_file') && (value != '')) {
            responses[index][name] = e.target.files[0];
          }
        else{
        responses[index][name] = value; 
        } 
        this.setState({auditResponse: {...auditResponse, responses}});
    }

    handleDateChangeRaw = (event) => {
        event.preventDefault();
    };

    handleDateChange = (date, index) => {
        const {auditResponse} = this.state;
        let responses = [...auditResponse.responses];
        responses[index].audit_date = moment(date);
        this.setState({auditResponse: {...auditResponse, responses}});
    };

    saveResponse = async () => {
        this.setState({isLoading: true, isPrintLoading: true});
        
        try {
            const {responses} = this.state.auditResponse;
            let yesCount = 0;
            const fileData = [];
            const formData = [];
            responses.forEach(element => {
                const {form_file, ...rest} = element
                
                const auditDate = moment(element.audit_date).format("YYYY-MM-DD");
                yesCount += element.compliance === COMPLIANCE_YES ? 1 : 0;
                formData.push({...rest, audit_date: auditDate && auditDate !== "Invalid date" ? auditDate : null,});
                fileData.push(form_file);
                }); 
            const {compensation, auditId, auditKPI} = this.props;
            const compId = compensation && compensation.id ? compensation.id : 0;

            let result = await this.props.updateAuditResponse(
                formData, compId,auditKPI, auditId
            );
            for (var i = 0 ; i < fileData.length; i++ ){ 
                let results = await this.props.fileuploadResponse(
                    fileData[i], compId, formData[i].id

                );   
            } 
            if (result) {
                toast.success("Saved Successfully.");
                const totalItems = responses.length;
                const score = totalItems > 0 ? (yesCount * 100 / totalItems) : 0;
                this.setState({
                    auditResponse: {...this.state.auditResponse, score} 
                });
            }
            this.getAuditForm();           
        } 
        catch (error) {
            toast.error(<ErrorMsg errors={error}/>);
        }
        this.setState({isLoading: false, isPrintLoading: false});
    }

    printReport = async () => {
        const {compensation, auditId} = this.props;
        const compId = compensation && compensation.id ? compensation.id : 0;
        this.setState({isPrintLoading: true});
        let result = await this.props.printAuditResponse(compId, auditId);
        if (result) {
            let content = result.content;
            let fileName = result.file_name;
            downloadPDF(content, fileName);
        } else {
            toast.error("Audit form is not available. Please contact admin.");
        }
        this.setState({isPrintLoading: false});
    }

    handlePDFDownload = async (fileName) => {
        let path = "review_form/" + fileName
        var fileDownload = require('js-file-download');
        this.setState({isPrintLoading: true});
        let result = await ComplianceAuditService.DownloadPDF(path);
        if (result) {
            let content = result.data;
            fileDownload (content, fileName);
        } else {
            toast.error("File Not found");
        }
        this.setState({isPrintLoading: false});
    }

    deleteItem = async(id) => {
        let data = [];
        const {auditResponse} = this.state;
        data.push(id)
        let res = await ComplianceAuditService.deleteAuditResponse(data);
        try{
            if (res){
                toast.error('Deleted Successfully');
                let newItemList = this.state.auditResponse.responses.filter(
                    item => id !== Number(item.id)
                );
                this.setState({auditResponse: {...auditResponse, responses : newItemList } });
            }
        }
        catch (error) {
            toast.error(<ErrorMsg errors={error}/>);
        }
        // const {responses} = this.state.auditResponse;   
        // await responses.map((res,index) => {
        //     if ( res.id === id){
        //         res.form_file = ''
        //         this.setState({
        //             auditResponse: {...auditResponse, responses}
        //         });
        //     }
        // });
        // let newItemList = this.state.auditResponse.responses.filter(
        //     item => id !== Number(item.id)
        // );
        // this.setState({delete_audit_res : this.state.delete_audit_res.concat(data) ,auditResponse: {...auditResponse, responses : newItemList } });
    };

    renderAuditItems = () => {
        const {auditResponse} = this.state;
        const {responses} = auditResponse;
        const {isArchived} = this.props;
        return responses.map((response,index) => {
            let disabled = auditResponse.status !== REVIEW_OPEN || isArchived ;

            return (
            <div className="card border border-info rounded mb-3" key={index}>
                <div className="card-header bg-info text-white py-2 ">
                    <div className='row'>
                        <div className='col-md-11'>
                            <label className="mb-0">
                                {response.audit_category}
                            </label>
                        </div>
                        <div className='col-md-1 text-right'>
                        <a href='#' onClick={() => this.deleteItem(response.id)} ><i className="fa fa-trash text-danger" style={{fontSize: '150%', paddingRight : '10%'}} 
                          ></i></a>
                    
                        </div>
                    </div>
                </div>
                <div className="card-body py-3 bg-f9">
                    <div className="row">
                        <div className="col-12 mb-2">
                            <input className="py-2 px-3 text-center form-control"
                                value={response.audit_item_text}
                                disabled={true}
                            />
                        </div>
                        <div className="col-sm-6 col-md-4 mb-2">
                            <label className="mb-0">Date</label>
                            <div className="div-datepicker">
                                <DatePicker
                                    selected={response.audit_date}
                                    onChangeRaw={this.handleDateChangeRaw}
                                    onChange={
                                        (e) => this.handleDateChange(e, index)
                                    }
                                    dateFormat="MM-DD-YYYY"
                                    fixedHeight showMonthDropdown showYearDropdown
                                    dropdownMode="select"
                                    minDate={moment().subtract(1, 'year')}
                                    maxDate={moment()}
                                    autoComplete="off"
                                    className="form-control"
                                    disabled={disabled}
                                />
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4 mb-2">
                            <label className="mb-0">Customer Name</label>
                            <input
                                
                                name="customer_name"
                                className="form-control"
                                value={response.customer_name}
                                onChange={(e) => this.handleAuditData(e, index)}
                                disabled={disabled}
                            />
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <label className="mb-0">Compliance</label>
                            <select className="form-control"
                                value={response.compliance}
                                name="compliance"
                                onChange={(e) => this.handleAuditData(e, index)}
                                disabled={disabled}
                            >
                                <option value="Pending">Pending</option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                        </div>
                       
                        <div className="col-sm-6 col-md-12">
                         <label className="mb-0">Details</label>
                         
                             <div style = {disabled === false ? {border:"1px solid #e9ecef" , background:"#fff"} : {border:"1px solid #e9ecef" , background:"#e9ecef"}}>
                                 
                                <Input 
                                    type="textarea" rows={2}
                                    name="details"
                                    className="form-control col-md-12"
                                    style={{ border : " #ffffff"}}
                                    value={response.details}
                                    onChange={(e) => this.handleAuditData(e, index)}
                                    disabled={disabled}
                                    
                                />
                                <div className="col-md-12 row">
                                 <label className="col-md-10 " style={{paddingLeft: '72%'}} ><a href = "#"  onClick={() => this.handlePDFDownload(response.file_name)}>{response.file_name}</a></label>
                                 <Input 
                                        type="file" 
                                        accept="image/*, application/pdf"
                                        className="form-control col-md-2"
                                        style={{float: 'right', border : " #ffffff"}}
                                        name="form_file"
                                        onChange={(e) => this.handleAuditData(e, index)}
                                        disabled={disabled}
                                />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            )
           
        });
    
    }

    printAuditEmptyForm = async (e) => {
        this.setState({isPrintLoading: true});
        await this.props.printAuditEmptyForm(e);
        this.setState({isPrintLoading: false});
    }

    openConfirmation = (e) => {
        e.preventDefault();
        let showConfirmModal = true, size="sm", hide=this.closeConfirmationModal;
        let msgTitle = "Confirmation!";
        const {auditResponse} = this.state;
        if (auditResponse.status !== REVIEW_OPEN) {
            toast.error("Reviews are already completed or closed.");
            return false;
        }
        let msgBody = <div>
            Once marked as Completed, you would not be able to edit it.<br/>
            Are you sure, You want to continue?
        </div>
        let buttons = [
            {
                className: "btn btn-success",
                onClick: this.completeReview,
                label: "Yes"
            },
            {
                className: "btn btn-default",
                onClick: this.closeConfirmationModal,
                label: "No"
            }
        ];
        this.setState({
            confirmationModalData: {
                showConfirmModal, size, hide, msgTitle, msgBody, buttons
            }
        });
        return false;
    }

    closeConfirmationModal = () => {
        this.setState({
            confirmationModalData: {
                ...this.state.confirmationModalData, showConfirmModal: false
            }
        });
    }

    completeReview = async() => {
        const {auditResponse} = this.state;
        try {
            const result = await this.props.AuditAction({
                type: UPDATE_AUDIT_STATUS, 
                auditId: auditResponse.id,
                auditObj: {status: REVIEW_COMPLETED}
            });
            if (result) {
                this.setState({auditResponse: {
                    ...auditResponse, status: REVIEW_COMPLETED
                }});
                toast.success("Status updated successfully.")
            }
        } catch (error) {
            toast.error(<ErrorMsg errors={error}/>)
        }
    }

    render() {
        const {
            auditResponse, isLoading, isPrintLoading, confirmationModalData
        } = this.state;
        const {
            modal, toggleModal, user, compensation, permission, isArchived
        } = this.props;

        return (
            <Modal isOpen={modal} size="xl" toggle={toggleModal}>
                <ModalHeader toggle={toggleModal}>
                    {`${user && user.id ? user.full_name + ' - ' : ''}`}Review Form ({
                        compensation && compensation.date_range
                    })
                </ModalHeader>
                <ModalBody className="bg-white" 
                    style={{maxHeight: "calc(100vh - 130px)", overflowY: 'auto'}}
                >
                    <div className="row mb-2">
                        <div className="col-12">
                           <label className="mb-0">{auditResponse.description}</label>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            {this.renderAuditItems()}
                            {isLoading && 
                                <p className="loading-gif">
                                    <img src={loadingGIF} alt="Loading..." 
                                        width="32" height="32"
                                    />
                                </p>
                            }
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter className="d-flex justify-content-between align-items-center">
                    <label className="mb-0" style={{width: "100px"}}>
                        Score: <NumberFormat value={auditResponse.score} 
                            displayType={'text'} decimalScale={2} 
                            thousandSeparator={true} suffix={'%'} 
                        />
                    </label>
                    <div className="w-75 d-flex justify-content-end">
                        {isPrintLoading && 
                            <img src={loadingGIF} alt="loading..." height="32" width="32"/> 
                        }
                        {auditResponse.responses.length > 0 && 
                            <React.Fragment>
                                {auditResponse.status === REVIEW_OPEN && !isArchived &&
                                    <label className="mb-0 d-flex align-items-center pr-2">
                                        <input type="checkbox" name="status" 
                                            value={auditResponse.status === REVIEW_COMPLETED} 
                                            checked={auditResponse.status === REVIEW_COMPLETED} 
                                            onChange={this.openConfirmation}
                                        /> 
                                        <span className="pl-1">Mark as Completed</span>
                                    </label>
                                }
                                {permission && permission.can_edit && (
                                    auditResponse.status === REVIEW_OPEN && !isArchived
                                ) &&
                                    <Button className='btn btn-success mr-2' 
                                        onClick={this.saveResponse}
                                        disabled={isLoading || isPrintLoading}
                                    >
                                        Save
                                    </Button>
                                }
                                <Button className='btn btn-info mr-2' 
                                    onClick={this.printReport}
                                    disabled={isPrintLoading}
                                >
                                    Print
                                </Button>
                                <Button className='btn btn-info mr-2' 
                                    onClick={this.printAuditEmptyForm}
                                    disabled={isPrintLoading}
                                >
                                    Print Empty Form
                                </Button>
                            </React.Fragment>
                        }
                        <Button className='btn btn-secondary' onClick={toggleModal}>
                            Close
                        </Button>
                    </div>
                    {confirmationModalData.showConfirmModal &&
                        <ConfirmModal {...confirmationModalData} />
                    }
                </ModalFooter>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/staffDashboardNav/AuditForm.js